import React from 'react'
import {
  RacingMarketType,
  RacingPropositionType,
} from '@core/Areas/VenueMode/Components/Racing/Data/types'
import { ContainerStyled } from '@core/Areas/VenueMode/Components/Racing/RacingPropositions.styles'
import { RacingProposition } from '@core/Areas/VenueMode/Components/Racing/RacingProposition'

export interface VenueModeRacingPropositionsProps {
  propositions: RacingPropositionType[]
  market: RacingMarketType
  selectedItem: RacingPropositionType | null
  onSelectedItemChanged: (proposition: RacingPropositionType) => void
}

export const RacingPropositions: React.FC<VenueModeRacingPropositionsProps> = ({
  propositions,
  market,
  selectedItem,
  onSelectedItemChanged,
}) => (
  <ContainerStyled>
    {propositions.map(proposition => (
      <RacingProposition
        proposition={proposition}
        market={market}
        selectedItem={selectedItem}
        onSelectedItemChanged={onSelectedItemChanged}
        key={proposition.sequence}
      />
    ))}
  </ContainerStyled>
)
